module.exports = __webpack_public_path__ + "static/media/campusreels.43458621.svg";